(function () {
  'use strict';
  angular.module('ringbaPortal').controller('LogoutController', LogoutController);

  function LogoutController(
    $state,
    $scope,
    authService
  ) {
    'ngInject';

    const vm = this;

    vm.$state = $state;
    vm.authService = authService;
    vm.$onInit = onInit;

    function onInit() {
      vm.authService.logOut();
      vm.$state.go('login');
    }

  }
})();

